/* eslint-disable prettier/prettier */
import { createSlice } from "@reduxjs/toolkit";

export const tavSlice = createSlice({
  name: "tav",
  initialState: {
    citas: [],
    isloadingCitas: true,
    citasProximas: [],
    isloadingCitasProximas: true,
    citasAnteriores: [],
    isloadingCitasAnteriores: true,
    docCitas: {},
    isloadingDocs: true,
    loading: false,
  },
  reducers: {
    setCitas: (state, action) => {
      state.citas = action.payload;
      state.isloadingCitas = false;
    },
    isLoadingCitas: (state) => {
      state.isloadingCitas = true;
    },
    setCitasProximas: (state, action) => {
      state.citasProximas = action.payload;
      state.isloadingCitasProximas = false;
    },
    isLoadingCitasProximas: (state) => {
      state.isloadingCitasProximas = true;
    },
    setCitasAnteriores: (state, action) => {
      state.citasAnteriores = action.payload;
      state.isloadingCitasAnteriores = false;
    },
    isLoadingCitasAnteriores: (state) => {
      state.isloadingCitasAnteriores = true;
    },
    setCitaAdd: (state, action) => {
      state.citas.unshift(action.payload);
    },
    removeCita: (state, action) => {
      const idCita = action.payload;
      state.citas = state.citas.filter((cita) => cita.idCita !== idCita);
    },
    setCitaProxAdd: (state, action) => {
      state.citasProximas.unshift(action.payload);
    },
    removeCitaProx: (state, action) => {
      const idCita = action.payload;
      state.citasProximas = state.citasProximas.filter((cita) => cita.idCita !== idCita);
    },
    updateCita: (state, action) => {
      const index = state.citasProximas.findIndex((u) => u.idCita === action.payload.idCita);
      if (index !== -1) {
        state.citasProximas[index] = action.payload;
      }
    },
    setDocs: (state, action) => {
      state.citas = state.citas.map((item) => {
        if (item.idCita === action.payload.idCita) {
          return {
            ...item,
            documentos: action.payload.data,
            loading: action.payload.estatus,
          };
        }
        return item;
      });
      state.isloadingDocs = false;
    },
    setDocsAnt: (state, action) => {
      state.citasAnteriores = state.citasAnteriores.map((item) => {
        if (item.idCita === action.payload.idCita) {
          return {
            ...item,
            documentos: action.payload.data,
            loading: action.payload.estatus,
          };
        }
        return item;
      });
      state.isloadingDocs = false;
    },
    isLoadingDocs: (state) => {
      state.isloadingDocs = true;
    },
    updateLoadingDescarga: (state, action) => {
      if (action.payload.tabla == "citas") {
        state.citasAnteriores = state.citasAnteriores.map((item) => {
          if (item.idDocumentoCita === action.payload.idDocumentoCita) {
            return {
              ...item,
              loading: action.payload.valor,
            };
          }
          return item;
        });
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCitas,
  isLoadingCitas,
  setCitasProximas,
  isLoadingCitasProximas,
  setCitasAnteriores,
  isLoadingCitasAnteriores,
  setCitaAdd,
  removeCita,
  setCitaProxAdd,
  removeCitaProx,
  updateCita,
  setDocs,
  setDocsAnt,
  isLoadingDocs,
  updateLoadingDescarga,
} = tavSlice.actions;

export default tavSlice.reducer;
